import { cssColorValue, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Label = styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-1c0cv3r-0"
})(["color:", ";"], cssColorValue(semanticColors.textBase));